<!-- global markup for header -->
<header class="header">
	<div class="content">
		<div class="header__block row">
			<div class="header__arrow col image" (click)="handleArrowPress()">
				<img src="/assets/images/header/back-arrow.svg" alt="arrow" />
				<span style="color: white; font-size: 18px">חזרה</span>
			</div>
			<div class="header__title col clickable" (click)="selectedGroup$.next(null); selectedMonth$.next(null)">{{ title$ | async }}</div>
		</div>
	</div>

	<div class="report-table__row">
		<!-- <div class="header__search header__search_small" style="width: 99%; margin: auto; margin-top: 10px">
			<button class="header__search-icon image" style="position: absolute; top: 50%; left: 5%" (click)="search()">
				<img src="/assets/images/header-search.svg" alt="search" />
			</button>
			<input
				dir="rtl"
				class="header__search-input"
				(keyup)="search()"
				type="text"
				[placeholder]="'חפש ' + (isAgents ? 'סוכנים' : isGroups ? 'מחלקות' : 'לקוחות')"
				[formControl]="searchControl"
				style="text-align: center"
			/>
			<button class="header__clear-icon" (click)="SearchClear()"></button>
		</div> -->
		<!-- <h3 class="report-table__row__totals" *ngIf="!Loading">סה"כ: <span>{{total$ | async | number : '1.0-2'}}</span></h3> -->
	</div>

	<h2 style="text-align: center" *ngIf="Loading">טוען אנא המתן</h2>
</header>

<!-- start report table markup -->
<section class="report-table" *ngIf="!Loading">
	<div class="content">
		<form [formGroup]="form" dir="rtl" *ngIf="hasMultipleCompanies">
			<div class="row flex gap justify-align-center">
				<div style="margin-top: 10px; font-size: 15.5px; font-weight: 425">
					<select formControlName="company">
						<option *ngFor="let company of companies" [value]="company.Company">{{ company.CompanyName }}</option>
					</select>
				</div>
			</div>
		</form>

		<h1 *ngIf="selectedGroup$ | async as group" class="clickable" (click)="selectedMonth$.next(null)">
			{{ group.text }}
		</h1>
		<h1 *ngIf="selectedMonth$ | async as month">
			{{ month | returnHebrewDate : 'month' : true }}
		</h1>

		<div class="report-table__row report-table__row_between">
			<div class="flex-row">
				<mat-button-toggle-group color="primary" *ngIf="canChangeSumOrQuantity$ | async" [formControl]="sumOrQuantityControl">
					<mat-button-toggle [ngClass]="{ active: sumOrQuantityControl.value === 'sum' }" value="sum">סכום</mat-button-toggle>
					<mat-button-toggle [ngClass]="{ active: sumOrQuantityControl.value === 'quantity' }" value="quantity">כמות</mat-button-toggle>
				</mat-button-toggle-group>
			</div>
			<div class="flex-row" *ngIf="isAdmin">
				<app-excel-button onlyEmit (clicked)="downloadExcel()"></app-excel-button>
			</div>
		</div>
		<div class="report-table__row report-table__row_full-width" style="margin-right: 0px">
			<ng-container [ngSwitch]="pageMode$ | async">
				<table class="report-table__table" cellspacing="0" *ngSwitchCase="'groups'">
					<thead class="report-table__table-head" style="border: unset">
						<tr>
							<th class="report-table__table-head-name" style="width: 30px" *ngFor="let header of tableHeaders$ | async">
								{{ header.text }}
							</th>
						</tr>
					</thead>
					<tbody class="report-table__table-body">
						<tr *ngFor="let row of displayValuesGroup$ | async" [ngClass]="{ clickable: (selectedMonth$ | async) === null }" (click)="handleRowClick(row)">
							<td class="report-table__table-body-name" *ngFor="let data of tableData$ | async">
								{{ data.format === 'month' ? (row[data.key] | returnHebrewDate : 'month' : true) : data.format === 'number' ? (row[data.key] | number : '1.0-2') : row[data.key] }}
							</td>
						</tr>
					</tbody>
				</table>
			</ng-container>
		</div>
	</div>
</section>
